import { Lightbox } from "./Lightbox.js";

/**
 * Class to implement the lightbox manager
 * as a singleton, which can be instantiated by
 * any other extension as a dependency
 */
export class LightboxManager {
    private static manager: LightboxManager;
    private instances: Lightbox[] = [];

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        this.lightboxes.forEach((lightbox) => {
            this.instances.push(new Lightbox(lightbox));
        });
    }

    /**
     * Method to instantiate all
     * lightboxes on the current page
     *
     * @param {boolean} [reset=false]
     * @returns {LightboxManager}
     */
    public static use(reset: boolean = false): LightboxManager {
        if (!LightboxManager.manager || reset) {
            LightboxManager.manager = new LightboxManager();
        }
        return LightboxManager.manager;
    }

    /**
     * Selects the lightboxes
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get lightboxes(): NodeListOf<HTMLElement> {
        return document.querySelectorAll(`[scope="lightbox"][role="dialog"]`);
    }

    /**
     * Returns the number of instantiated lightboxes
     *
     * @returns {number}
     */
    public get length(): number {
        return this.instances.length;
    }
}
